/**
 * The connection dialog's TanStack form, typed once so the dialog's hooks share one form type (Option C, C0).
 */
import { useForm } from '@tanstack/react-form';
import type { ConnectionFormValues } from '../../components/connectionFormSchema';

export function useConnectionForm(defaultValues: ConnectionFormValues, onSubmit: (values: ConnectionFormValues) => Promise<void>) {
  return useForm({ defaultValues, onSubmit: ({ value }) => onSubmit(value) });
}

export type ConnectionForm = ReturnType<typeof useConnectionForm>;
